import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function PriceTagIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path d="M14.1668 5a.8336.8336 0 01.7699.5144.8331.8331 0 01-1.4628.7819.8338.8338 0 01.1037-1.0522A.833.833 0 0114.1668 5zM1.9085 9.8166l7.9-7.8833a.8337.8337 0 01.6083-.2667h5a.8331.8331 0 01.5917.2417l2.0833 2.075a.8335.8335 0 01.2417.5917v5a.875.875 0 01-.2417.5916l-7.9083 7.9167a.8751.8751 0 01-.5917.2417.8335.8335 0 01-.5916-.2417l-7.0917-7.0917a.8328.8328 0 01-.2417-.5916.875.875 0 01.2417-.5834zm7.6833 6.5084l7.075-7.0834v-4.325l-1.5833-1.5833h-4.3167l-7.0833 7.075 5.9083 5.9167z"/>
    </SvgIcon>
  )
}
export default PriceTagIcon
